import { createSelector } from 'reselect';
import { initialState } from './reducer';

/**
 * Direct selector to the confirmProfile state domain
 */

const selectConfirmProfileDomain = state =>
  state.confirmProfile || initialState;

/**
 * Other specific selectors
 */

/**
 * Default selector used by ConfirmProfile
 */

const selectConfirmProfileData = () =>
  createSelector(
    selectConfirmProfileDomain,
    substate => substate.confirmProfileData,
  );

const selectConfirmProfileList = () =>
  createSelector(
    selectConfirmProfileDomain,
    substate => substate.confirmProfileList,
  );

const selectConfirmProfileLoading = () =>
  createSelector(
    selectConfirmProfileDomain,
    substate => substate.loading,
  );

const selectConfirmProfileError = () =>
  createSelector(
    selectConfirmProfileDomain,
    substate => substate.error,
  );

const selectConfirmProfileDeleteSuccessful = () =>
  createSelector(
    selectConfirmProfileDomain,
    substate => substate.deleteSuccessful,
  );

export {
  selectConfirmProfileDomain,
  selectConfirmProfileLoading,
  selectConfirmProfileError,
  selectConfirmProfileDeleteSuccessful,
  selectConfirmProfileData,
  selectConfirmProfileList,
};
